export const formatNumber = (value?: string | number, decimalPlaces?: number, addPlusOrMin?: boolean) => {
    const prefix = addPlusOrMin ? parseInt(value) > 0 ? '+ ' : '- ' : ''
    const number = addPlusOrMin ? Math.abs(value) : value

    return number || number === 0
        ? prefix + parseFloat(`${number}`).toFixed(decimalPlaces || 2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(",00", "")
        : '-'
}
